jQuery( function( $ ) {
    "use strict"

    vector.smoothScrollAll();
    vector.menuDropdown( '.header__inner li.menu-item-has-children' );
    vector.mobileMenu( '#mobile__menu', '#mobile__menu--button', '#mobile__menu--screen' );

} );



// WEBPACK FOOTER //
// ./resources/assets/scripts/app.js